import omit from 'lodash/omit';
import omitBy from 'lodash/omitBy';

import type { IKybDetails } from '../types';

export const modifyKybFormReqData = (data: Partial<IKybDetails>, token: string) => {
	const modifiedData = omit(data, ['email']);

	const officialTelephoneData = modifiedData.officialTelephone ?? '';
	const officialTelephone = typeof officialTelephoneData === 'string' ? officialTelephoneData : String(officialTelephoneData);

	const taxIdData = modifiedData.taxId ?? '';
	const taxId = typeof taxIdData === 'string' ? taxIdData : String(taxIdData);

	return omitBy(
		{ ...modifiedData, token, officialTelephone, taxId },
		(value) => !value || value === '' || (Array.isArray(value) && value.length === 0) || Number.isNaN(value)
	);
};

export const kybDefaultAboutData = {
	companyName: '',
	officialEmail: '',
	taxId: '',
	officialTelephone: '',
	proofOfAddress: '',
	evidenceOfRegistration: '',
	memart: '',
	statusReport: '',
	extraDoc: '',
	country: '',
	businessDescription: '',
};

export const kybDefaultData: IKybDetails = {
	token: '',
	...kybDefaultAboutData,
	directors: [],
	acknowledged: false,
	status: undefined,
};

export const defaultKybCredentials = {
	email: '',
	token: '',
};

export const sanitizeKybReqData = (data: Partial<IKybDetails>) =>
	omit(data, ['createdAt', 'status', 'updatedAt', '_id', 'processedBy', 'reason', 'id']);
